export function scrollToElement(target: Element | string, options?: { smooth?: boolean; gap?: number }): void {
  const element = typeof target === "string" ? document.getElementById(target.startsWith("#") ? target.slice(1) : target) : target;
  if (!element) return;

  const header = document.querySelector("header");
  const headerHeight = header ? (header as HTMLElement).offsetHeight : 0;
  const gap = options?.gap ?? 0;
  const offset = headerHeight + gap;
  const targetPosition = element.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: targetPosition - offset,
    behavior: options?.smooth ? "smooth" : "auto",
  });
}
